import React, { Component } from 'react';
// reactstrap imports removed - using native Bootstrap modal structure
import toastr from 'toastr';
import Loadable from 'react-loading-overlay';
import urlParse from 'url-parse';
import reactWindowSize from 'react-window-size';
import 'video-react/dist/video-react.css';
import apiClient from '../util/api-client';
import { showCapacityLimitPopup } from '../util/capacity-popup'; // FIX 20260724-uploadmsg
import AnimationGetUrlModal from './AnimationGetUrlModal';
import AnimationUploaderModal from './AnimationUploaderModal';
import PublicUrlModal from './PublicUrlModal';
import { reload as reloadActivities } from './ActivitiesButton';
import GetUrlYoutube from './GetUrlYoutube'
import CaptureUrlSelectModal from './CaptureUrlSelectModal'
import LimitCaptureUrlModal from './LimitCaptureUrlModal'
import LimitSpeedUploadModal from './LimitSpeedUploadModal'
import IconUploadYoutubeDrive from 'images/upload_youtube_drive.png';
import IconUploadCapture from 'images/icon-www.png';
import IconUploadImage from 'images/upload_image.png';
import IconUploadVideo from 'images/upload_video.png';


const ONE_GB_TO_BYTES = Math.pow(2,30);
const PLANS = ['free', 'minimum', 'basic', 'master']
const PLANS_TEXT = ['無料','ミニマム','ベーシック','マスター']

// Single registry to store component instance for upload modal
window.uploadAnimationSingleton = null;

class UploadAnimationInAkaireFileList extends Component {
  constructor(props) {
    super(props);
    const {
        baseURL, last_page_id, is_create_video_embed, is_create_pass_video, current_total_size,
        akaire_file_id, akaire_file_pages, uploaded_data_info, is_free_or_light_plan,
        can_use_google, default_gdrive_logic, hide_google_instruction, hide_youtube_instruction, current_plan
    } = props;
    this.props = { ...this.props, ...props };
    this.state = {
      user: {},
      project: {},
      loadingText: null,
      percentComplete: 0,
      animations: [],
      markers: [],
      pages: akaire_file_pages || [],
      currentAnimationId: null,
      currentPageId: last_page_id,
      assignments: [],
      shouldShowGetUrlModal: false,
      shouldShowProjectShareModal: false,
      shouldShowProjectFormModal: false,
      shouldShowAnimationUploaderModal: false,
      shouldShowAnimationUploaderImageModal: false,
      shouldShowCompletionModal: false,
      shouldShowPublicUrlModal: false,
      shouldShowGetUrlYoutube: false,
      shouldShowCaptureUrlSelectModal: false,
      shouldShowLimitCaptureUrlModal: false,
      shouldShowLimitSpeedUploadModal: false,
      shouldShowUploadVersionModal: false,
      LimitSpeedUploadModalShowed: false,
      isLoading: false,
      activeTab: 'markers',
      timerCheckAnimation: null,
      responseConvertVideo: null,
      timerDownloadExtensionFile: null,
      downloadExtensionUrl: null,
      convertFile: false,
      completed: 0,
      finishConvert: false,
      changeCss: false,
      uploadedDataInfo: uploaded_data_info,
      isNewAnimationCreated: false,
      membersInComment: [],
      animationSelectCurrent: null,
      is_create_video_embed: is_create_video_embed,
      is_capture_video_youtube: false,
      is_cancel_capture_video_youtube: false,
      isShowFullscreenAnimation: false,
      is_create_pass_video: is_create_pass_video,
      isShowInputPassVideo: false,
      passwordShareVideo: '',
      isDisabledButtonSavePass: true,
      isShowInputDemo: false,
      currentPasswordShareVideo: '',
      currentTotalSize: current_total_size,
      selectedPageId: null,
      selectedPageTitle: '',
      nextVersionNumber: 1,
      akaireFileId: akaire_file_id,
      limitUploadVideo: null,
      limitUploadImage: null,
      limitUploadPdf: null,
      isFreeOrLightPlan: is_free_or_light_plan,
      can_use_google: can_use_google,
      default_gdrive_logic: default_gdrive_logic,
      hide_google_instruction: hide_google_instruction,
      hide_youtube_instruction: hide_youtube_instruction,
      currentPlan: current_plan,
    };
    this.currentURL = baseURL;
    this.baseURL = baseURL;
    this.apiClient = apiClient({ baseURL: this.baseURL });
    this.percentConvert = null;
  }

  componentDidMount() {
    // Register this instance for external access
    window.uploadAnimationSingleton = this;

    $(document).on('tm-modal-back-click hide.bs.modal hidden.bs.modal', '#uploadVersionPopup', () => {
      if (this.state.shouldShowUploadVersionModal) {
        this.hideUploadVersionModal();
      }
    });

    // If there were pending props requested before mount, load them now
    if (window.pendingUploadAnimationProps) {
      this.loadProps(window.pendingUploadAnimationProps);
      window.pendingUploadAnimationProps = null;
      return;
    }

    // Initialize selected page if pages exist from initial props
    const { pages } = this.state;
    if (pages && pages.length > 0) {
      const lastPage = pages[pages.length - 1];
      let nextVersion = 1;
      if (lastPage.animations && lastPage.animations.length > 0) {
        const versionTitle = lastPage.animations[lastPage.animations.length - 1].title;
        nextVersion = Number(versionTitle) + 1;
      }

      this.setState({
        selectedPageId: lastPage.id,
        selectedPageTitle: lastPage.title,
        nextVersionNumber: String(nextVersion).padStart(2, '0')
      });
    }
  }

  componentWillUnmount() {
    // Unregister this instance
    if (window.uploadAnimationSingleton === this) {
      window.uploadAnimationSingleton = null;
    }
    
    $(document).off('tm-modal-back-click hide.bs.modal hidden.bs.modal', '#uploadVersionPopup');
  }

  componentDidUpdate(_, prev) {
    const { is_cancel_capture_video_youtube, is_capture_video_youtube } = this.state;
    if (is_cancel_capture_video_youtube && is_capture_video_youtube !== prev.is_capture_video_youtube &&
      is_capture_video_youtube === false && prev.is_capture_video_youtube === true) {
      this.setState({is_cancel_capture_video_youtube: false})
    }
  }

  // Load props for specific akaire file and open modal
  loadProps = (newProps = {}) => {
    const {
      last_page_id,
      akaire_file_pages = [],
      akaire_file_id,
      baseURL,
      uploaded_data_info = {},
      current_total_size,
      is_create_video_embed,
      is_create_pass_video,
      limit_upload_video,
      limit_upload_image,
      limit_upload_pdf,
      is_free_or_light_plan,
      can_use_google,
      default_gdrive_logic,
      hide_google_instruction,
      hide_youtube_instruction,
      current_plan,
    } = newProps;

    let nextVersionNumber = '01';
    let selectedPageId = last_page_id;
    let selectedPageTitle = '';

    if (akaire_file_pages && akaire_file_pages.length > 0) {
      // tìm page theo last_page_id, nếu không có thì lấy page cuối
      let targetPage = akaire_file_pages.find(p => p.id === last_page_id);
      if (!targetPage) {
        targetPage = akaire_file_pages[akaire_file_pages.length - 1];
      }

      if (targetPage) {
        selectedPageId = targetPage.id;
        selectedPageTitle = targetPage.title || '';

        if (targetPage.animations && targetPage.animations.length > 0) {
          const lastAni = targetPage.animations[targetPage.animations.length - 1];
          const versionTitle = lastAni && lastAni.title ? lastAni.title : '0';
          nextVersionNumber = String(Number(versionTitle) + 1).padStart(2, '0');
        }
      }
    }

    this.baseURL = baseURL;

    this.setState({
      ...this.state,
      ...newProps,
      pages: akaire_file_pages,
      akaireFileId: akaire_file_id,
      baseURL: baseURL || this.baseURL,
      uploadedDataInfo: uploaded_data_info,
      currentTotalSize: current_total_size,
      is_create_video_embed,
      is_create_pass_video,
      selectedPageId,
      selectedPageTitle,
      nextVersionNumber,
      shouldShowUploadVersionModal: true,
      limitUploadVideo: limit_upload_video,
      limitUploadImage: limit_upload_image,
      limitUploadPdf: limit_upload_pdf,
      isFreeOrLightPlan: is_free_or_light_plan,
      can_use_google: can_use_google,
      default_gdrive_logic: default_gdrive_logic,
      hide_google_instruction: hide_google_instruction,
      hide_youtube_instruction: hide_youtube_instruction,
      currentPlan: current_plan,
    });
  };

  // Method to hide upload version modal
  hideUploadVersionModal = () => {
    this.setState({ shouldShowUploadVersionModal: false });
  }

  // Method to handle page selection in upload version modal
  handleSelectPage = (pageId, pageTitle, totalAnimations) => {
    const { pages } = this.state;
    let nextVersion = 1;
    const page = pages.find(page => page.id === pageId);
    if (page) {
        if (page.animations && page.animations.length > 0) {
            const versionTitle = page.animations[page.animations.length - 1].title;
            nextVersion = Number(versionTitle) + 1;
        }
    }
    this.setState({
    selectedPageId: pageId,
    selectedPageTitle: pageTitle,
    nextVersionNumber: String(nextVersion).padStart(2, '0')
    });
  }

  // Method to handle upload type selection and open corresponding modal
  handleSelectUploadType = (type) => {
    const { selectedPageId } = this.state;
    
    // Set the page ID for upload (this will be used by the upload modals)
    // Store in a hidden element that the upload modals can access
    const uploadVersionPopup = document.getElementById(`uploadVersionPopup`);
    if (uploadVersionPopup) {
      uploadVersionPopup.setAttribute('data-page-id', selectedPageId);
    }
    
    // Also set on a generic element for backward compatibility
    const genericPopup = document.getElementById('uploadVersionPopup');
    if (genericPopup) {
      genericPopup.setAttribute('data-page-id', selectedPageId);
    }

    // Clean up Bootstrap modal state so no leftover backdrop/body class blocks the next popup inputs
    const $popup = $('#uploadVersionPopup');
    if ($popup.data('bs.modal')) {
      $popup.modal('hide');
    }
    $('.modal-backdrop').remove();
    document.body.classList.remove('modal-open');

    // Hide the upload version modal first
    this.setState({ shouldShowUploadVersionModal: false }, () => {
      // Then open the corresponding modal based on type
      switch(type) {
        case 'video':
          this.open('AnimationUploaderModal');
          break;
        case 'youtube':
          this.open('CaptureUrlSelectModal');
          break;
        case 'capture':
          this.open('GetUrlModal');
          break;
        case 'image':
          this.open('AnimationUploaderImageModal');
          break;
        default:
          break;
      }
    });
  }

  // toggleElementList(className, show = true) {
  //   const elementList = document.getElementsByClassName(className);
  //   for (let i = 0; i < elementList.length; i ++) {
  //     elementList[i].style.visibility = show ? "visible" : "hidden";
  //   }
  // }

  currentAnimation = () => this.state.animations.find(_ => _.id === this.state.currentAnimationId)
  // fromProjectId = () => {
  //   return url.searchParams.get('from_project_id');
  // }
  // fromTaskId = () => {
  //   return url.searchParams.get('from_task_id');
  // }
  // fromWorkId = () => {
  //   return url.searchParams.get('from_work_id');
  // }
  // fromPageId = () => {
  //   return url.searchParams.get('from_page_id');
  // }
  // fromAkaireFileId = () => {
  //   return url.searchParams.get('from_file_id');
  // }
  textFor = (plan) => {
    return PLANS.indexOf(plan) >= 0 && PLANS_TEXT[PLANS.indexOf(plan)]
  }
  showAlertLimitVideo = () => {
    const {current_limit_video: currentLimitVideo, current_subscription_type: currentSubscriptionType} = this.props;
    const nextLevelPlan = this.textFor(PLANS[PLANS.indexOf(currentSubscriptionType)+1])
    const text = nextLevelPlan ? `${nextLevelPlan}プラン以上にアップグレードするか、データの圧縮をしてからアップロードをお願い致します。` : ''
    toastr.error(`${this.textFor(currentSubscriptionType)}プランの場合、1回でのアップロード制限は${currentLimitVideo}GB以内です。${text}`);
  }

  convertVideo = ({ signedUrl }, filename) => {
    this.startLoading();
    const { selectedPageId: pageId, akaireFileId } = this.state;
    var id_interval = setInterval(() => {
      this.apiClient.put(
        `/akaire_feature/akaire_files/${akaireFileId}/animations/convert_mp4`,
        {
          pathname: decodeURI(urlParse(signedUrl).pathname),
          page_id: pageId,
          filename: filename,
          from_akaire_file_id: akaireFileId,
        }) // decode the file name to the correct original name
        .then((res) => {
          if (res.data.type == 'success') {
            setTimeout(() => {
              toastr.success('動画をアップロードしました。');
              reloadActivities();
              this.setState({ convertFile: false });
              this.finishConvert(true)
            }, 1000);
            setTimeout(() => {
              this.close('AnimationUploaderModal');
            }, 2000);
            clearInterval(id_interval);
            this.reloadAfterUpload(res.data.page_id, res.data.animation_id)
          }
        })
        .catch(() => {
          this.endLoading();
          this.close('AnimationUploaderModal');
        })
    }, 2000);
  }
  file_extension = (filename) => {
    const extensions = filename.split('.').slice(-1)
    if (extensions.length) { return extensions[0].toUpperCase() }
  }

  onClickInputFile = () => {
    this.fetchUploadedInfo();
  }

  fetchUploadedInfo = () => {
    const { akaireFileId } = this.state;
    return this.apiClient.get(`/akaire_feature/akaire_files/${akaireFileId}/uploaded_data_info`)
      .then(_ => this.setState({ uploadedDataInfo: _.data }))
      .catch(console.error);
  }

  toggle = bool => name => {
    // When closing a child modal and returning to upload version modal, sync React state
    // so that the modal is controlled by React. Otherwise Bootstrap state (backdrop, body class)
    // can leave an invisible overlay that blocks inputs when opening a popup again.
    const showUploadVersionModal = !bool && $('#uploadNewPagePopup').attr('data-upload-new') != 'true';
    this.setState({
      [`shouldShow${name}`]: bool,
      ...(showUploadVersionModal ? { shouldShowUploadVersionModal: true } : {})
    });
    if(!bool) {
      if($('#uploadNewPagePopup').attr('data-upload-new') == 'true') {
        $('#uploadNewPagePopup').modal('show')
      } else {
        $('#uploadVersionPopup').modal('show')
      }
    }
  }
  open = this.toggle(true)
  close = this.toggle(false)

  checkExistsExtension = (extension) => {
    const { currentAnimationId} = this.state;
    this.startLoading();
    const message_error = '動画のダウンロードに失敗しました。';
    return this.apiClient.post(
      `/akaire_feature/akaire_files/${akaireFileId}/animations/${currentAnimationId}/extension_files/check_exists`,
      { extension: extension }
    )
      .then(_ => {
        const { data, status } = _;
        if (data.status == 'prepare' || data.status == 'started') {
          if (data.status == 'prepare') { this.create_extension(extension) };
          if (data.status == 'started') { this.checkProgressPercent(extension) };
        } else {
          if (data.status == 'finished' || data.status == 'error') {
            clearInterval(this.timerDownloadExtensionFile);
            this.setState({ timerDownloadExtensionFile: null })
            this.setState({ percentComplete: 0 });
          }
          if (data.status == 'finished') {
            toastr.success('動画をダウンロードしました。');
            window.location.href = data.url;
          }
          if (data.status == 'error') { toastr.error(message_error); }
          this.endLoading();
        }
      })
      .catch((e) => {
        toastr.error(message_error);
        this.endLoading();
      })
  }
  checkProgressPercent = (extension) => {
    const currentAnimation = this.currentAnimation();
    const timeConvert = currentAnimation && currentAnimation.file_size ? ((((currentAnimation.file_size / 1024) * 10000) / (40 * 1024)) + 10000) / 100 : 1000;
    const timeForTimerDownload = timeConvert < 5000 ? 5000 : timeConvert + 1000;
    clearInterval(this.timerDownloadExtensionFile);
    this.timerDownloadExtensionFile = setInterval(() => {
      clearInterval(this.percentConvert);
      this.percentConvert = null;
      this.percentConvert = setInterval(() => {
        const { percentComplete, loadingText } = this.state;
        if (percentComplete < 99 && loadingText && loadingText.includes('converting')) {
          let text = loadingText.replace(/[\d%]/g,'');
          text += '\n' + percentComplete + '%';
          this.setState({ loadingText: text });
          this.setState({ percentComplete: percentComplete + 1 });
        }
      }, timeConvert);
      this.checkExistsExtension(extension)
    }, timeForTimerDownload);
  }
  create_extension = (extension) => {
    const { currentAnimationId } = this.state;
    this.apiClient.post(`animations/${currentAnimationId}/extension_files`, { extension: extension })
      .then(res => {
        this.checkProgressPercent(extension);
      })
      .catch((e) => {
        this.endLoading();
      })
  }

  onFinishUpload = ({ signedUrl }, filename, duration=0) => {
    const { akaireFileId, selectedPageId: pageId } = this.state;
    this.apiClient.post(
      `/akaire_feature/akaire_files/${akaireFileId}/animations`,
      {
        pathname: decodeURI(urlParse(signedUrl).pathname),
        page_id: pageId,
        filename: filename,
        from_akaire_file_id: akaireFileId,
        duration: duration
      })
      .then(async(response) => {
        this.setState({ currentAnimationId: response.data.animation_id })
        if (!this.state.convertFile) {
          toastr.success('動画をアップロードしました。');
          this.close('AnimationUploaderModal');
          this.reloadAfterUpload(response.data.page_id, response.data.animation_id, response.data.page_id, filename.includes('.mp4') ? '' : 'video')
        }
      })
      .catch(() => {
        this.endLoading();
        toastr.error('動画のアップロードに失敗しました。');
      })
  }
  onFinishUploadImage = ({ signedUrl }, filename, pdfMetadata = null) => {
    const { akaireFileId, selectedPageId: pageId } = this.state;
    this.startLoading();
    return this.apiClient.post(
      `/akaire_feature/akaire_files/${akaireFileId}/animations`,
      {
        pathname: urlParse(signedUrl).pathname,
        filename: filename,
        page_id: pageId,
        from_akaire_file_id: akaireFileId,
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({ currentAnimationId: response.data.animation_id })
          if (filename.split('.').pop() == 'pdf') {
            if (pdfMetadata && pdfMetadata.isSmallPdf) {
              const urlConvert = `/akaire_feature/akaire_files/${akaireFileId}/animations/check_status_convert_pdf?animation_id=${response.data.animation_id}&page_id=${pageId}`
              var id_interval = setInterval(() => {
                this.apiClient.get(urlConvert)
                  .then((res) => {
                    if (res.data.type == 'success') {
                      setTimeout(() => {
                        toastr.success('PDFをアップロードしました。');
                        reloadActivities();
                        this.finishConvert(true)
                      }, 1000);
                      setTimeout(() => {
                        this.close('AnimationUploaderModal');
                        this.endLoading();
                        this.reloadAfterUpload(res.data.page_id, res.data.animation_id)
                      }, 500);
                      clearInterval(id_interval);
                    }
                  })
                  .catch(() => {
                    Popup.alert(`PDFファイルを画像に変換処理が失敗しました。再度やり直してください。`)
                    clearInterval(id_interval);
                    this.endLoading();
                    this.close('AnimationUploaderModal');
                  })
              }, 5000);
            } else {
              this.close('AnimationUploaderModal');
              this.reloadAfterUpload(response.data.page_id, response.data.animation_id)
            }
          } else {
            toastr.success('画像をアップロードしました。');
            this.reloadAfterUpload(response.data.page_id, response.data.animation_id)
          }
        }
      })
      .catch(() => {
        this.endLoading();
        toastr.error('画像のアップロードに失敗しました。');
      })
  }
  onUploadImage = (isSuccess, pageId, dataResponse = {}) => {
    reloadActivities();
    this.startLoading();
    if (isSuccess) {
      let type = ''
      if (dataResponse?.type == 'capture_url') {
        if (dataResponse.exceedingLimitAllowsCapture) {
          if (dataResponse.needUpgradePlan) {
            type = 'exceeding_limit_and_need_upgrade_plan'
          } else {
            type = 'exceeding_limit_allows_capture'
          }
        } else {
          type = 'capture_url'
        }
      }
      setTimeout(() => {
        this.reloadAfterUpload(pageId, dataResponse.animation_id)
      }, 500)
    } else {
      this.setState({ LimitSpeedUploadModalShowed: false })
      this.close('LimitSpeedUploadModal')
    }
  }
  startLoading = (title, loadingText, notDispatch = false) => {
    this.fadeInLoader();
    $('.message_overlay').removeClass('d-none')
    this.setState({ isLoading: true }, () => {
      if (notDispatch) return;
      const event = new CustomEvent('akaireLoadingStateChange', {
        detail: { isLoading: true, loadingText: "" }
      });
      document.dispatchEvent(event);
    });
    if (this.props.is_free_or_light_plan && !this.state.LimitSpeedUploadModalShowed) {
      this.setState({ shouldShowLimitSpeedUploadModal: true, LimitSpeedUploadModalShowed: true })
      setTimeout(() => {
        $('.limit-speed-upload-modal').parent().parent().parent().css('z-index', '9999')
      }, 100)
    }
  }
  endLoading = (uploadSuccess = false) => {
    if (!uploadSuccess) {
      this.setState({ loadingText: null, isLoading: false });
      $('.message_overlay').addClass('d-none')
    }
    $('.preloader').fadeOut();
    clearInterval(this.percentConvert);
    this.percentConvert = null;

    const event = new CustomEvent('akaireLoadingStateChange', {
      detail: { isLoading: false, loadingText: null }
    });
    document.dispatchEvent(event);
  }
  convertFile = (file) => this.setState({ convertFile: file })
  finishConvert = (type) => {
    this.setState({ finishConvert: type })
  }
  startUploadVideo = (file) => {
    const {current_limit_video: currentLimitVideo} = this.props;
    const { user: {total_file_size: totalFileSize, total_file_size_on_this_cycle: totalAllCycle, max_storage: maxStorage, total_file_size_limit: totalFileSizeLimit } } = this.state;
    var file_size = parseInt(file.size);
    if (file_size / ONE_GB_TO_BYTES > currentLimitVideo) {
      this.showAlertLimitVideo();
      return
    }
    // FIX 20260724-uploadmsg 容量超過は共通モーダル（プラン変更ボタン付き）で案内する
    if (file_size + Number(totalAllCycle) > Number(totalFileSizeLimit) || file_size + Number(totalFileSize) > Number(maxStorage)) {
      showCapacityLimitPopup(this.state.uploadedDataInfo || {});
      return;
    }
    this.startLoading();
  }

  reloadAfterUpload = (pageId, animation_id, page_new, type = '') => {
    const { akaireFileId } = this.state;

    const path =  `/akaire_feature/akaire_files/${akaireFileId}?update_version_page=${pageId}&animation_id=${animation_id}`;

    window.location.href = `${window.location.origin}${path}`;
  }

  showUploadSuccess = () => {
    setTimeout(() => {
      this.endLoading(true);
    }, 2000)
  }

  fadeInLoader = () => {
    const pageId = $('#uploadVersionPopup').attr('data-page-id')
    if(pageId) {
      $('.preloader').fadeIn();
      setInterval(() => {
        $('.preloader').css('opacity', 0.2)
      }, 200);
    }
  }

  changeIsShowInputVideo = () => {
    const {isShowInputPassVideo, passwordShareVideo} = this.state
    if (isShowInputPassVideo) {
      if (!passwordShareVideo || passwordShareVideo === '') {
        this.setPasswordForShareVideo('', false);
        this.setState({
          isShowInputPassVideo: !isShowInputPassVideo,
          passwordShareVideo: ''
        })
        return
      }
      Popup.confirm(
        `パスワード設定をOFFにすると<br>設定したパスワードはリセットされます。<br>OFFにしてよろしいですか？`,
        {
          success: () => {
            this.setPasswordForShareVideo('', false);
            this.setState({
              isShowInputPassVideo: !isShowInputPassVideo,
              passwordShareVideo: ''
            })
          },
          cancel: () => {},
          confirmText: 'OK',
          width: 'auto',
        }
      )
      return
    }
    this.setState({
      isShowInputPassVideo: !isShowInputPassVideo,
      passwordShareVideo: ''
    })
  }

  setPasswordForShareVideo = (password, isshowPopup = true) => {
    const {currentAnimationId} = this.state
    this.apiClient.post(
      `animations/change_password_share_video`,
      { password: password, id: currentAnimationId }
    )
      .then(res => {
        if (isshowPopup) {
          Popup.alert('パスワードを保存しました。')
        }
      })
      .catch((e) => {
        Popup.alert(`An error occurred`)
        this.endLoading();
      })
  }

  checkPassWord = (event) => {
    const pass = $(event.target).val()
    this.setState({ passwordShareVideo: pass })
    if (pass.length >= 6) {
      this.setState({isDisabledButtonSavePass: false})
    } else {
      this.setState({isDisabledButtonSavePass: true})
    }
  }

  changeFocus = () => {
    const {isShowInputDemo} = this.state
    this.setState({isShowInputDemo: !isShowInputDemo});
  }

  closeModalShareVideo = () => {
    const {currentPasswordShareVideo, passwordShareVideo} = this.state
    if (currentPasswordShareVideo !== passwordShareVideo) {
      Popup.confirm(`パスワードが保存されていません。<br>閉じてよろしいですか？`, {
        success: () => {
          this.setState({
            [`shouldShowPublicUrlModal`]: false, passwordShareVideo: currentPasswordShareVideo,
            isShowInputDemo: true,
          })
        },
        confirmText: 'OK',
      })
      return
    }
    this.setState({ [`shouldShowPublicUrlModal`]: false })
  }

  transitToYoutube = () => {
    this.setState({
      shouldShowCaptureUrlSelectModal: false,
      shouldShowGetUrlYoutube: true
    })
  }

  transitToCaptureUrl = () => {
    this.setState({
      shouldShowCaptureUrlSelectModal: true,
      shouldShowGetUrlYoutube: false
    })
  }


  // Render the Upload Version Modal
  renderUploadVersionModal() {
    const { shouldShowUploadVersionModal, pages, selectedPageId, selectedPageTitle, nextVersionNumber } = this.state;
    const isOpen = shouldShowUploadVersionModal;
    const modalClassName = `modal fade${isOpen ? ' show' : ''} upload-new-version-list-akaire-file`;
    const modalStyle = { display: isOpen ? 'block' : 'none', backgroundColor: isOpen ? 'rgba(0,0,0,0.5)' : 'transparent', zIndex: 1050 };

    return (
      <div 
        className={modalClassName}
        id="uploadVersionPopup"
        data-task-type="video"
        data-page-id={selectedPageId}
        tabIndex="-1"
        aria-labelledby="errorModalLabel"
        aria-hidden={isOpen ? 'false' : 'true'}
        role="dialog"
        style={modalStyle}
        onClick={(e) => {
          if (!isOpen) return;
          if (e.target === e.currentTarget) this.hideUploadVersionModal();
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-style" role="document">
          <div className="modal-content">
            <div className="modal-body text-center">
              <p className="modal-title font-weight-bold">
                バージョンを更新する
              </p>
              <div className="select-page-box position-relative dropdown">
                <div className="current-page d-flex cursor-pointer">
                  <div 
                    className="text-left text-ellipsis col-4 akaire-page-name dropdown-toggle current-page-name-id-for-akaire-page"
                    data-toggle="dropdown"
                    data-tooltip="tooltip"
                    data-placement="bottom"
                    title={selectedPageTitle}
                  >
                    {selectedPageTitle || 'ページ1'}
                  </div>
                  <div className="select-page cursor-pointer dropdown-menu">
                    <div className="col-4">
                        {pages && pages.map((page) => (
                            <React.Fragment key={page.id}>
                                <p 
                                    className="mb-0 text-left text-ellipsis option-select-page"
                                    data-page-id={page.id}
                                    data-total-version={page.animations ? page.animations.length + 1 : 1}
                                    data-tooltip="tooltip"
                                    data-placement="bottom"
                                    title={page.title}
                                    onClick={() => this.handleSelectPage(page.id, page.title, page.animations ? page.animations.length : 0)}
                                >
                                    {page.title}
                                </p>
                            </React.Fragment>
                        ))}
                    </div>
                    <div className="col-1 text-center">&gt;</div>
                    <div className="col-7 p-0 count-total-version px-0 text-center">
                    Ver {String(nextVersionNumber).padStart(2, '0')} にアップロードされます。
                    </div>
                  </div>
                  <div className="col-1">&gt;</div>
                  <div className="col-7 count-total-version-view px-0">
                    Ver {String(nextVersionNumber).padStart(2, '0')} にアップロードされます。
                  </div>
                </div>
              </div>
              <div className="select-type-upload">アップロードの種類を選択</div>
              <div className="select-type-animation mt-4">
                <div className="text-left create-akaire-box-content">
                  <a 
                    href="javascript:void(0)" 
                    className="create-akaire-box-link nav-link link-upload-video-akaire-page" 
                    onClick={() => this.handleSelectUploadType('video')}
                  >
                    <img 
                      className="create-akaire-box-icon-upload filter-black-icon mr-4"
                      src={IconUploadVideo} 
                      alt="アップロード" 
                      width="40" 
                      height="40" 
                    />
                    動画データを校正する
                  </a>
                  <a 
                    href="javascript:void(0)" 
                    className="create-akaire-box-link nav-link" 
                    onClick={() => this.handleSelectUploadType('youtube')}
                  >
                    <img 
                      className="create-akaire-box-icon-upload mr-4"
                      src={IconUploadYoutubeDrive} 
                      alt="アップロード" 
                      width="40" 
                      height="40" 
                    />
                    オンラインコンテンツを校正する
                  </a>
                  <a 
                    href="javascript:void(0)" 
                    className="create-akaire-box-link nav-link" 
                    onClick={() => this.handleSelectUploadType('capture')}
                  >
                    <img 
                      className="create-akaire-box-icon-upload mr-4"
                      src={IconUploadCapture} 
                      alt="アップロード" 
                      width="40" 
                      height="40" 
                    />
                    WEBサイトのURLを校正する
                  </a>
                  <a 
                    href="javascript:void(0)" 
                    className="create-akaire-box-link nav-link link-upload-image-akaire-page" 
                    onClick={() => this.handleSelectUploadType('image')}
                  >
                    <img 
                      className="create-akaire-box-icon-upload mr-4"
                      src={IconUploadImage} 
                      alt="アップロード" 
                      width="40" 
                      height="40" 
                    />
                    画像またはPDFを校正する
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderNormal() {
    const { current_user_id: id, root_url: rootUrl,
      is_free_plan: isFreePlan, current_limit_video: currentLimitVideo, token_public_url: token_public_url,
      is_akapon_member: isAkaponMember, is_project_owner_member, isAkaponProject, is_upload_multiple_files,
    } = this.props;
    const {
      loadingText, isLoading, shouldShowGetUrlModal, shouldShowAnimationUploaderModal, shouldShowAnimationUploaderImageModal,
      shouldShowPublicUrlModal, completed, user, uploadedDataInfo, shouldShowGetUrlYoutube,
      shouldShowCaptureUrlSelectModal, is_create_video_embed, is_create_pass_video, isShowInputPassVideo, passwordShareVideo, isDisabledButtonSavePass,
      isShowInputDemo, shouldShowLimitCaptureUrlModal, shouldShowLimitSpeedUploadModal, akaireFileId,
      limitUploadVideo, limitUploadImage, limitUploadPdf, isFreeOrLightPlan, can_use_google, default_gdrive_logic,
      hide_google_instruction, hide_youtube_instruction, currentPlan
    } = this.state;
    const currentAnimation = this.currentAnimation();
    const token = token_public_url;
    const public_video_token = currentAnimation && currentAnimation.url_token;

    return (
      <div className="show-animation-in-akaire-file-list">
        {/* Upload Version Modal - rendered outside Loadable for proper z-index */}
        {this.renderUploadVersionModal()}
        
        <Loadable
          className="loading-overlay"
          active={isLoading}
          zIndex={10000}
        >
          <div className="message_overlay d-none">
          { loadingText }
          </div>

          <AnimationGetUrlModal uploadedDataInfo={uploadedDataInfo} isOpen={shouldShowGetUrlModal} onClickClose={this.close.bind(this, 'GetUrlModal')}
            token={token}
            rootUrl={rootUrl} onFinish={this.onUploadImage} projectId={id}
            onStart={this.startLoading.bind(this, 'Now uploading...')} currentPlan={currentPlan}
            isFreeOrLightPlan={isFreeOrLightPlan}
            baseURL={this.baseURL} taskID={id} isAkaponProject={isAkaponProject} isCreateOfTemp={true}
            isUploadMultipleFiles={is_upload_multiple_files} endLoading={this.endLoading}/>
          <GetUrlYoutube isOpen={shouldShowGetUrlYoutube}
            onClickTransitionUrlSelect={this.transitToCaptureUrl}
            onClickClose={this.close.bind(this, 'GetUrlYoutube')} token={token}
            rootUrl={rootUrl} onFinish={this.onUploadImage} projectId={id}
            onStart={this.startLoading.bind(this, 'Now uploading...')}
            baseURL={`/akaire_feature/akaire_files/${akaireFileId}/`} endLoading={this.endLoading}
            is_create_video_embed={is_create_video_embed}
            hideInstruction={hide_youtube_instruction}
            onReloadAfterUpdate={this.showUploadSuccess}
            isUploadByAkaireFileList={true}
            akaireFileId={akaireFileId}
          />
          <CaptureUrlSelectModal
            uploadedDataInfo={uploadedDataInfo}
            isOpen={shouldShowCaptureUrlSelectModal}
            onClickTransitionYoutube={this.transitToYoutube}
            onClickClose={this.close.bind(this, 'CaptureUrlSelectModal')} token={token}
            onStart={this.startLoading.bind(this, 'Now uploading...')}
            onFinish={this.onFinishUpload}
            onReloadAfterUpdate={this.reloadAfterUpload}
            statusConvert={this.finishConvert} finishConvert={this.state.finishConvert}
            rootUrl={rootUrl} projectId={id}
            hideGoogleInstruction={hide_google_instruction}
            canUseGoogle={can_use_google}
            baseURL={this.baseURL} endLoading={this.endLoading}
            defaultGdriveLogic={default_gdrive_logic}
            limitUploadPdf={limitUploadPdf} limitUploadVideo={limitUploadVideo} limitUploadImage={limitUploadImage}
            currentPlan={currentPlan}
            isFreeOrLightPlan={isFreeOrLightPlan}
            isAkaireFileList={true}
          />
          <AnimationUploaderModal
            convertVideo={this.convertVideo}
            isOpen={shouldShowAnimationUploaderModal}
            onClickClose={this.close.bind(this, 'AnimationUploaderModal') }
            onStart={this.startUploadVideo} onFinish={this.onFinishUpload} projectId={id}
            baseURL={`/akaire_feature/akaire_files/${akaireFileId}/`} completed={completed}
            convertFile={this.convertFile} statusConvert={this.finishConvert} finishConvert={this.state.finishConvert} endLoading={this.endLoading}
            type={'video'} user={user}
            oneGb={ONE_GB_TO_BYTES} currentLimitVideo={currentLimitVideo} uploadedDataInfo={uploadedDataInfo}
            onClickInputFile={this.onClickInputFile} is_mobile={false} currentTotalSize={this.state.currentTotalSize}
            isUploadMultipleFiles={is_upload_multiple_files}
            limitUploadPdf={limitUploadPdf} limitUploadVideo={limitUploadVideo}
            limitUploadImage={limitUploadImage}
            isFreeOrLightPlan={isFreeOrLightPlan}
          />
          <AnimationUploaderModal convertVideo={this.convertVideo} isOpen={shouldShowAnimationUploaderImageModal} onClickClose={this.close.bind(this, 'AnimationUploaderImageModal')}
            onStart={this.startUploadVideo} onFinish={this.onFinishUploadImage} projectId={id}
            baseURL={`/akaire_feature/akaire_files/${akaireFileId}/`} completed={completed}
            convertFile={this.convertFile} statusConvert={this.finishConvert} finishConvert={this.state.finishConvert} endLoading={this.endLoading}
            type={'image'} user={user} oneGb={ONE_GB_TO_BYTES} currentLimitVideo={currentLimitVideo}
            uploadedDataInfo={uploadedDataInfo} onClickInputFile={this.onClickInputFile} is_mobile={false} currentTotalSize={this.state.currentTotalSize}
            limitUploadPdf={limitUploadPdf} limitUploadVideo={limitUploadVideo}
            limitUploadImage={limitUploadImage}
            isFreeOrLightPlan={isFreeOrLightPlan}
           />
          <PublicUrlModal isOpen={shouldShowPublicUrlModal} onClickClose={this.closeModalShareVideo} ad={isFreePlan} currentAnimation={currentAnimation} type={this.props.project_type} token={token} public_video_token={public_video_token} is_create_pass_video={is_create_pass_video} isShowInputPassVideo={isShowInputPassVideo}
            changeIsShowInputVideo={this.changeIsShowInputVideo} setPasswordForShareVideo={this.setPasswordForShareVideo}
            passwordShareVideo={passwordShareVideo} checkPassWord={this.checkPassWord}
            isDisabledButtonSavePass={isDisabledButtonSavePass} isAkaponMember={isAkaponMember}
            is_project_owner_member={is_project_owner_member}
            isShowInputDemo={isShowInputDemo} changeFocus={this.changeFocus} />
          <LimitCaptureUrlModal isOpen={shouldShowLimitCaptureUrlModal} onClickClose={this.close.bind(this, 'LimitCaptureUrlModal')} currentPlan={currentPlan} />
          <LimitSpeedUploadModal isOpen={shouldShowLimitSpeedUploadModal} onClickClose={this.close.bind(this, 'LimitSpeedUploadModal')} />
        </Loadable>
      </div>
    )
  }

  render() {
    return this.renderNormal();
  }
}

export default reactWindowSize(UploadAnimationInAkaireFileList);

export { UploadAnimationInAkaireFileList };
